<template>
    <div class="flex checkbox-group">
        <input
            type="checkbox"
            :id="option.title"
            :value="inputValue"
            v-model="model"
            :disabled="model.length >= max && !model.includes(inputValue)"
            @change="$emit('setTouched')"
        />
        <label :for="option.title">
            {{ option.title }}
        </label>
    </div>
</template>

<script>
    export default {
        name: "InputCheckbox",
        props: ["option", "name", "inputValue", "value", "max"],
        computed: {
            model: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        },
    };
</script>

<style scoped>
    .flex {
        display: flex;
    }

    label {
        display: block;
        text-align: center;
        border: 2px solid #e6e7e8;
        border-radius: 50px;
        padding: 1rem 2rem;
        cursor: pointer;
        width: 100%;
        margin-bottom: 1rem;
        font-size: 14px;
        color: #424244;
        transition: all 0.2s ease;
    }

    label:hover {
        background: var(--c-light-grey);
        border-color: var(--c-link);
    }

    @media (min-width: 900px) {
        label {
            font-size: 20px;
            border-radius: 30px;
        }
    }

    input {
        display: none;
    }

    input[disabled] + label {
        opacity: 0.5;
        cursor: not-allowed;
    }

    input:checked + label {
        background: #fff;
        border-color: var(--c-red);
        color: var(--c-red);
    }
</style>
